import React from 'react';
import './About.css';

const About = () => {
  const teamMembers = [
    {
      name: 'Rajesh Kumar',
      position: 'CEO & Founder',
      image: '👨‍💼',
      description: '15+ years in IT industry with expertise in enterprise solutions'
    },
    {
      name: 'Priya Sharma',
      position: 'CTO',
      image: '👩‍💻',
      description: 'Full-stack developer and cloud architecture specialist'
    },
    {
      name: 'Amit Patel',
      position: 'Lead Developer',
      image: '👨‍🔧',
      description: 'Expert in React, Node.js and modern web technologies'
    },
    {
      name: 'Sneha Desai',
      position: 'UI/UX Designer',
      image: '👩‍🎨',
      description: 'Creative designer focused on user experience and modern design'
    }
  ];

  return (
    <div className="about">
      <div className="about-hero">
        <div className="container">
          <h1 className="about-title">About LogicSphere Technologies</h1>
          <p className="about-subtitle" id="about-subtitle">
            Empowering businesses through innovative technology solutions since 2019
          </p>
        </div>
      </div>

      <section className="company-story section">
        <div className="container">
          <div className="story-content">
            <div className="story-text">
              <h2>Our Story</h2>
              <p>
                Founded in 2019 in Pune, LogicSphere Technologies Pvt Ltd emerged from a vision 
                to bridge the gap between complex technology and business needs. Our founders, 
                with decades of combined experience in the IT industry, recognized the need for 
                a company that could deliver both technical excellence and business value.
              </p>
              <p>
                Starting as a small team of passionate developers, we have grown into a 
                comprehensive IT services company serving clients across various industries. 
                Our journey has been marked by continuous learning, innovation, and an 
                unwavering commitment to client success.
              </p>
              <p>
                Today, we are proud to be recognized as one of Pune's leading technology 
                companies, known for our expertise in web development, mobile applications, 
                cloud solutions, and IT support services.
              </p>
            </div>
            <div className="story-image">
              <div className="story-image-wrap">
                <img
                  src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&auto=format&fit=crop"
                  alt="Modern office workspace at LogicSphere Technologies"
                />
                <p className="story-image-caption">Our office — Orchid Complex, Bajirao Rd, Sadashiv Peth, Pune</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="values section">
        <div className="container">
          <h2 className="section-title">Our Values</h2>
          <p className="section-subtitle">
            The principles that guide everything we do
          </p>
          
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">🎯</div>
              <h3>Excellence</h3>
              <p>We strive for the highest quality in everything we deliver, continuously improving our processes and outcomes.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">🤝</div>
              <h3>Collaboration</h3>
              <p>We believe in working closely with our clients as partners, fostering open communication and mutual trust.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">💡</div>
              <h3>Innovation</h3>
              <p>We embrace new technologies and creative solutions to solve complex business challenges.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">🛡️</div>
              <h3>Integrity</h3>
              <p>We conduct business with honesty, transparency, and ethical practices in all our interactions.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">📈</div>
              <h3>Growth</h3>
              <p>We are committed to the growth of our clients, our team, and our company through continuous learning.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">⚡</div>
              <h3>Agility</h3>
              <p>We adapt quickly to changing requirements and market conditions, ensuring timely delivery.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="team section">
        <div className="container">
          <h2 className="section-title">Meet Our Team</h2>
          <p className="section-subtitle">
            The talented individuals who make LogicSphere successful
          </p>
          
          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <div key={index} className="team-card">
                <div className="team-image">{member.image}</div>
                <h3 className="team-name">{member.name}</h3>
                <p className="team-position">{member.position}</p>
                <p className="team-description">{member.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="achievements section">
        <div className="container">
          <h2 className="section-title">Our Achievements</h2>
          <p className="section-subtitle">
            Milestones that define our journey
          </p>
          
          <div className="achievements-timeline">
            <div className="timeline-item">
              <div className="timeline-year">2019</div>
              <div className="timeline-content">
                <h3>Company Founded</h3>
                <p>LogicSphere Technologies Pvt Ltd was established in Pune with a vision to deliver exceptional IT services.</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-year">2020</div>
              <div className="timeline-content">
                <h3>First Major Client</h3>
                <p>Secured our first enterprise client and successfully delivered a comprehensive web application.</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-year">2021</div>
              <div className="timeline-content">
                <h3>Team Expansion</h3>
                <p>Grew our team to 15+ professionals and expanded our service offerings to include mobile app development.</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-year">2022</div>
              <div className="timeline-content">
                <h3>Cloud Services Launch</h3>
                <p>Launched our cloud solutions division and became certified AWS and Azure partners.</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-year">2023</div>
              <div className="timeline-content">
                <h3>100+ Projects</h3>
                <p>Celebrated completing over 100 successful projects and serving 50+ satisfied clients.</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-year">2024</div>
              <div className="timeline-content">
                <h3>Future Ready</h3>
                <p>Continuing to innovate with AI/ML solutions and expanding our presence in the market.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;